import { Button } from "./ui/button";
import { ClipboardList, CheckCircle, Settings, GraduationCap,Zap } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { levelColors } from "../components/levelColors";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";

const MENU_ITEMS = [
  { id: "tests", name: "Tests", icon: ClipboardList, color: "text-blue-600" },
  { id: "completed", name: "Completed", icon: CheckCircle, color: "text-green-600" },
  { id: "settings", name: "Settings", icon: Settings, color: "text-gray-600" },
];

const LEVELS = [
  { value: "B1", label: "B1", color: "bg-purple-600" },
  { value: "B2", label: "B2", color: "bg-orange-500" },
  { value: "C1", label: "C1", color: "bg-pink-500" },
];

export function FloatingMenu({ activeSection, onSectionChange, selectedLevel, onLevelChange, Upgradetoggle }) {
  const history = useHistory(); 
  let params = new URL(document.location).searchParams;
  let tab   = params.get("tab");
  // const [showDropdown, setShowDropdown] = useState(false);
  // useEffect(() => {
  //   if (activeSection === "tests" || activeSection === "completed") {
  //     document.getElementById('set_bgcolor').classList.add('bg-gray-50');
  //   }
  // },[activeSection])
  useEffect(() => {
     if (tab === "completed") {
      onSectionChange("completed");
     }
  },[tab, onSectionChange])
  const handleMenuClick = (id) => {
    if (id === "settings") {
      history.push("/settings");
      window.location.reload(); 
    } else {
      onSectionChange(id);
    }
  };
  return (
    <div className="fixed top-7 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-white/80 backdrop-blur-md shadow-lg rounded-lg px-2 py-2">
        <div className="flex items-center">
        {MENU_ITEMS.map((item) => (
            <Button
            key={item.id}
            variant={activeSection === item.id ? "default" : "ghost"}
            className={`flex items-center px-2 sm:px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
              activeSection === item.id ? "bg-gray-100 scale-105" : "hover:bg-gray-100/50"
            }`}
            onClick={() => handleMenuClick(item.id)} 
          >
            <item.icon className={`h-5 w-5 ${item.color} mr-2`} />
            <span className={`${item.color} hidden sm:inline font-bold`}>{item.name}</span>
          </Button>
         ))}  
           {/* {showDropdown && (
            <ul className="absolute top-full left-40 transform -translate-x-1/2 mt-2 w-40 bg-white shadow-lg rounded-md overflow-hidden z-40 border border-gray-200 pl-0">
              <a href="/settings" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Account settings</a>
              <a href="/contact" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Contact</a>
              <a href="/logto_auth/signout" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Logout</a>
            </ul>
          )}       */}
          <div className="ml-1 sm:ml-2 border-l border-gray-200 pl-1 sm:pl-2">
            <Select value={selectedLevel} onValueChange={onLevelChange}>
              <SelectTrigger className="w-[180px] bg-transparent border-none h-10">
                <GraduationCap className="h-5 w-5 mr-2 text-gray-600" />
                <SelectValue placeholder="CEFR Level" />
              </SelectTrigger>
              <SelectContent className="bg-white rounded-md shadow-lg">
                {LEVELS.map((level) => (
                  <SelectItem key={level.value} value={level.value} className="focus:bg-gray-100 cursor-pointer">
                    <div className={`px-3 py-1 rounded-md ${level.color} text-white w-full text-center`}>
                      CEFR {level.label}
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="h-8 w-px bg-gray-200 mx-2"></div>
          <Button onClick={Upgradetoggle} className={`bg-gradient-to-r ${levelColors[selectedLevel]} text-white shadow-md transition-all duration-200 px-4 py-2`}>
            <Zap className="h-5 w-5 mr-2" />
            Upgrade
          </Button>
        </div>
      </div>
    </div>
  );
}
